import * as React from "react";
import { memo } from "react";
import "./filterSkeletonStyles.css";
export var FilterSkeletons = memo(function () {
    return (React.createElement("div", { className: "skeleton-filter-container" },
        React.createElement("div", { className: "skeleton-filter" }),
        React.createElement("div", { className: "skeleton-filter" }),
        React.createElement("div", { className: "skeleton-filter" })));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/views/filter/FilterSkeletons.tsx
// module id = 150
// module chunks = 1